import React from "react";
import { connect } from "react-redux";
import { Input, Row, InputGroup, InputGroupAddon, InputGroupText, Col, Label, Collapse, ListGroupItem, Button, ButtonGroup, FormGroup } from "reactstrap";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import { ButtonGroupAlignment } from "../../../../../components/UI/Buttons/ButtonGroupAlignment";
import { formActions } from "../../../../../store/actions/cms/form/form.action";
import TemplateSelect from "../../../../components/selects/TemplateSelect";
import ConfirmationSelect from "../../../../components/selects/ConfirmationSelect";
import { tempLangConverter } from "../../../../../helpers/lanugageHelper";
import { deepClone } from "../../../../../helpers/objectHelper";
import { AlignmentButtonGroup } from "../../../../components/editor/tools/AlignmentButtonGroup/AlignmentButtonGroup";
import ListExpansion from "../../../../../components/UI/ListExpansion/ListExpansion";
import { formSettings } from "../../models/formSettings";
import JirangoSwitch from "../../../../../components/UI/Switch/JirangoSwitch";
import { cmsActions } from "../../../../../store/actions/cms/cms.action";
import InheritageButtonGroup from "../../../../components/editor/tools/Inheritage/InheritageButtonGroup";
import LangInputGroup from "../../../../components/editor/LangInputGroup/LangInputGroup";

const WAIT_INTERVAL = 2000;
const ENTER_KEY = 13;

class FormSettings extends React.Component {
  state = {
    confirmationAreaIsExpanded: false,
    navigationAreaIsExpanded: false,
    submitAreaIsExpanded: false,
    templateAreaIsExpanded: false,
  };

  handleChange = (e, val, path) => {
    const { dispatch } = this.props;
    const names = path.split(".");
    const form = deepClone(this.props.form);
    let value = val !== null && val !== undefined ? val : e.target.value;

    if (names.length === 1) {
      form[names[0]] = value;
    }
    if (names.length === 2) {
      form[names[0]][names[1]] = value;
    } else if (names.length === 3) {
      form[names[0]][names[1]][names[2]] = value;
    } else if (names.length === 4) {
      form[names[0]][names[1]][names[2]][names[3]] = value;
    } else if (names.length === 5) {
      form[names[0]][names[1]][names[2]][names[3]][names[4]] = value;
    } else if (names.length === 6) {
      form[names[0]][names[1]][names[2]][names[3]][names[4]][names[5]] = value;
    }
    form.isChanged = true;

    dispatch(formActions.softUpdate(form));
  };
  expandArea = (area) => {
    this.setState(
      {
        [area]: !this.state[area],
      },
      () => {
        if (this.state.lastCollapse !== area) {
          if (this.state.lastCollapse !== "") {
            this.setState({ [this.state.lastCollapse]: false }, () => {
              this.setState({ lastCollapse: area });
            });
          } else {
            this.setState({ lastCollapse: area });
          }
        }
      }
    );
  };
  toggleInheritageInfo = (on) => {
    const { dispatch } = this.props;
    dispatch(cmsActions.toggleInheritageInfo(on));
  };
  toggleInheritageStatus = (status) => {
    const { dispatch } = this.props;
    const form = deepClone(this.props.form);
    form.inherit = status;
    form.isChanged = true;
    dispatch(formActions.softUpdate(form));
  };
  render() {
    const { form, cms } = this.props;
    let btnText = form && form.settings !== undefined && form.settings.submit.defaultLabel;
    if (
      cms.languageCode &&
      form &&
      form.settings !== undefined &&
      form.settings.submit.labels.find((l) => {
        return (l.languageCode.code || l.languageCode) === cms.languageCode;
      }).text !== ""
    ) {
      btnText = form.settings.submit.labels.find((l) => {
        return (l.languageCode.code || l.languageCode) === cms.languageCode;
      }).text;
    }
    if (form.settings === undefined) return null;
    return (
      <div>
        <ListExpansion footer={false} icon="fa fa-square" defaultExpanded={true} description="GlobalSettings">
          <Row>
            <Col className="list-setting-item-title" style={{ flexBasis: "unset", maxWidth: "100%" }}>
              <FormGroup style={{ width: "100%" }}>
                <Label htmlFor="form-name-label">
                  <SystemLabel name={`LocationExpLabel`} />
                </Label>
                <Input id="form-name-label" autoComplete="jirango-nofill" value={form.name} onChange={(e) => this.handleChange(e, null, `name`)} />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col className="list-setting-item-title">
              <Label>
                <SystemLabel name="AuthorizedFormMode" />
              </Label>
            </Col>
            <Col style={{ textAlign: "right" }}>
              <JirangoSwitch
                onChange={(e) => this.handleChange(null, !form.settings.authorizedFormMode, "settings.authorizedFormMode")}
                isChecked={form.settings.authorizedFormMode !== true ? false : true}
              />
            </Col>
          </Row>

          <hr />
          <Row>
            <Col className="list-setting-item-title">
              <Label>
                <SystemLabel name="ChangeToGroupLeaderOnSpecificPage" />
              </Label>
            </Col>
            <Col style={{ textAlign: "right" }}>
              <JirangoSwitch
                onChange={(e) => this.handleChange(null, !form.settings.changeToGroupLeaderOnSpecificPage, "settings.changeToGroupLeaderOnSpecificPage")}
                isChecked={form.settings.changeToGroupLeaderOnSpecificPage !== true ? false : true}
              />
            </Col>
          </Row>
          {form.settings.changeToGroupLeaderOnSpecificPage == true ? (
            <>
              <Row>
                <Col className="list-setting-item-title">
                  <FormGroup style={{ width: "100%" }}>
                    <Label htmlFor="form-name-label">
                      <SystemLabel name={`SpecificPage`} />
                    </Label>
                    <Input id="form-name-label" type="number" autoComplete="jirango-nofill" value={form.settings.specificPage} onChange={(e) => this.handleChange(e, null, `settings.specificPage`)} />
                  </FormGroup>
                </Col>
              </Row>
              <hr />
            </>
          ) : null}
          <Row>
            <Col className="list-setting-item-title">
              <Label>
                <SystemLabel name="OnlyGroupLeaderAllowedChangelink" />
              </Label>
            </Col>
            <Col style={{ textAlign: "right" }}>
              <JirangoSwitch
                onChange={(e) => this.handleChange(null, !form.settings.forceChangeOrderOnSpecificPage, "settings.onlyGroupLeaderAllowedChangelink")}
                isChecked={form.settings.forceChangeOrderOnSpecificPage !== true ? false : true}
              />
            </Col>
          </Row>

          <Row>
            <Col className="list-setting-item-title">
              <Label>
                <SystemLabel name="HideRegButton" />
              </Label>
            </Col>
            <Col style={{ textAlign: "right" }}>
              <JirangoSwitch
                onChange={(e) => this.handleChange(null, !form.settings.submit.hidden, "settings.submit.hidden")}
                isChecked={form.settings.submit.hidden && form.settings.submit.hidden == true ? true : false}
              />
            </Col>
          </Row>
          <hr />
          <Row>
            <Col className="list-setting-item-title">
              <FormGroup style={{ width: "100%" }}>
                <Label htmlFor="form-name-label">
                  <SystemLabel name={`GoogleAnalyticsId`} />
                </Label>
                <Input
                  id="form-name-label"
                  type="text"
                  autoComplete="jirango-nofill"
                  value={form.settings.googleAnalyticsId}
                  onChange={(e) => this.handleChange(e, null, `settings.googleAnalyticsId`)}
                />
              </FormGroup>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col className="list-setting-item-title">
              <FormGroup style={{ width: "100%" }}>
                <Label htmlFor="form-name-label">
                  <SystemLabel name={`FacebookId`} />
                </Label>
                <Input id="form-facebook-label" type="text" autoComplete="jirango-nofill" value={form.settings.facebookId} onChange={(e) => this.handleChange(e, null, `settings.facebookId`)} />
              </FormGroup>
            </Col>
          </Row>
        </ListExpansion>
        <br />
        <ListExpansion footer={false} icon="fa fa-square" defaultExpanded={true} description="TemplateAndConf">
          <Row style={{ paddingTop: "10px", paddingBottom: "10px" }}>
            <Col className="list-setting-item-title">
              <Label>
                <SystemLabel name="Template" />
              </Label>
            </Col>
            <Col className="list-setting-item-input">
              <TemplateSelect />
            </Col>
          </Row>

          <Row style={{ paddingTop: "10px", paddingBottom: "10px" }}>
            <Col className="list-setting-item-title">
              <Label>
                <SystemLabel name="WebConfirmation" />
              </Label>
            </Col>
            <Col className="list-setting-item-input">
              <ConfirmationSelect type="WEB" />
            </Col>
          </Row>
          <Row style={{ paddingTop: "10px", paddingBottom: "10px" }}>
            <Col className="list-setting-item-title">
              <Label>
                <SystemLabel name="EmailConfiramtion" />
              </Label>
            </Col>
            <Col className="list-setting-item-input">
              <ConfirmationSelect type="EMAIL" />
            </Col>
          </Row>
        </ListExpansion>
        <br />
        <ListExpansion footer={false} icon="fa fa-square" defaultExpanded={true} description="FormButtonSettings">
          <Row
            style={{
              justifyContent: "center",
              width: "100%",
              margin: "0px",
            }}
          >
            <Col style={{ padding: "0px" }} className="list-setting-item-title">
              <Label>
                <SystemLabel name="NextPageButtonName" />
              </Label>
              {form.settings.navigation.next.labels.map((l, index) => {
                return (
                  <React.Fragment key={index}>
                    <InputGroup className="mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className={`flag-icon flag-icon-${tempLangConverter(l.languageCode.code || l.languageCode)}`} />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        type="text"
                        autoComplete="jirango-nofill"
                        value={form.settings.navigation.next.labels[index].text}
                        placeholder="Label name.."
                        onChange={(e) => this.handleChange(e, null, `settings.navigation.next.labels.${index}.text`)}
                      />
                    </InputGroup>
                  </React.Fragment>
                );
              })}
            </Col>
          </Row>
          <Row
            style={{
              justifyContent: "center",
              width: "100%",
              margin: "0px",
            }}
          >
            <Col style={{ padding: "0px" }} className="list-setting-item-title">
              <Label>
                <SystemLabel name="PrevPageButtonName" />
              </Label>
              {form.settings.navigation.previous.labels.map((l, index) => {
                return (
                  <React.Fragment key={index}>
                    <InputGroup className="mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className={`flag-icon flag-icon-${tempLangConverter(l.languageCode.code || l.languageCode)}`} />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        type="text"
                        autoComplete="jirango-nofill"
                        value={form.settings.navigation.previous.labels[index].text}
                        placeholder="Label name.."
                        onChange={(e) => this.handleChange(e, null, `settings.navigation.previous.labels.${index}.text`)}
                      />
                    </InputGroup>
                  </React.Fragment>
                );
              })}
            </Col>
          </Row>
          <Row
            style={{
              justifyContent: "center",
              width: "100%",
              margin: "0px",
            }}
          >
            <Col style={{ padding: "0px" }} className="list-setting-item-title">
              <Label>
                <SystemLabel name="SubmitButtonName" />
              </Label>
              {form.settings.submit.labels.map((l, index) => {
                return (
                  <React.Fragment key={index}>
                    <InputGroup className="mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className={`flag-icon flag-icon-${tempLangConverter(l.languageCode.code || l.languageCode)}`} />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        type="text"
                        autoComplete="jirango-nofill"
                        value={form.settings.submit.labels[index].text}
                        placeholder="Label name.."
                        onChange={(e) => this.handleChange(e, null, `settings.submit.labels.${index}.text`)}
                      />
                    </InputGroup>
                  </React.Fragment>
                );
              })}
            </Col>
          </Row>
          {form.pages === 1 ? <AlignmentButtonGroup path="settings.submit.alignment" alignment={form.settings !== undefined && form.settings.submit.alignment} onChange={this.handleChange} /> : null}
          <br />
        </ListExpansion>

        <br />
        <ListExpansion footer={false} icon="fa fa-square" defaultExpanded={true} description="Inheritage">
          <Row>
            <Col className="list-setting-item-title">
              <Label>
                <SystemLabel name="ShowInheritageTooltips" />
              </Label>
            </Col>
            <Col style={{ textAlign: "right" }}>
              <JirangoSwitch onChange={(e) => this.toggleInheritageInfo(!cms.inheritInfo)} isChecked={cms.inheritInfo !== true ? false : true} />
            </Col>
          </Row>
          <InheritageButtonGroup onClick={this.toggleInheritageStatus} status={form.inherit} />
        </ListExpansion>
        <br />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    form: state.form,
    template: state.template,
    cms: state.cms,
  };
}

export default connect(mapStateToProps)(FormSettings);
